import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { StaffPointReset, TimePeriod } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimePeriodSelectComponent } from '../time-period-select/time-period-select.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'app-staff-point-reset',
    templateUrl: './staff-point-reset.component.html',
    styleUrls: ['./staff-point-reset.component.scss'],

    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        FlexLayoutModule,
        TimePeriodSelectComponent
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffPointResetComponent),
            multi: true
        }],

})
export class StaffPointResetComponent implements ControlValueAccessor {

  grp = new FormGroup({
    period: new FormControl(),
    baseDate: new FormControl(null, Validators.required)
  });

  constructor() {
    this.grp.valueChanges.subscribe(_ => this.notifyFormChanged());
  }

  /// ControlValueAccessor-------------------
  @Input('value') _value: any;
  onChange: any = () => {};
  onTouched: any = () => {};
  get value(): StaffPointReset {
    return this._value;
  }
  set value(o: StaffPointReset) {

    this._value = o;

    this.grp.patchValue({
      ...o
    }, { emitEvent: false });

    this.onChange(o);
    this.onTouched();
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    const o = this.getFormData();
    this._value = o;
    this.onChange(o);
    this.onTouched();
  }

  getFormData(): StaffPointReset {
    const f = this.grp.value;

    if (!f.period) return undefined;

    return new StaffPointReset({
      baseDate: f.baseDate ? new Date(f.baseDate) : undefined,
      period: this.getTimePeriod(f.period),
    });
  }

  getTimePeriod(period: any) : TimePeriod{
    if (!period)
      return undefined;

    var vPeriod = new TimePeriod();
    vPeriod.init(period);
    return vPeriod;
  }
}
